// @ts-check


import Network from '../../../../infrastructure/js/modules/network';
import * as liveMapService from '../../services/LiveMap/liveMapService.js';

import { createLabelHelper } from '../../../../infrastructure/js/utils/labelHelper';
import DateTimeHelper from '../../../../infrastructure/js/utils/dateTimeHelper';

import {navigationStates} from '../../enums/navigationStates';
import {api as navigatorApi} from '../AppTopbar/navigatorActions';



/**
 * @typedef {import("../../types/PL_ReduxTypes").ReduxDispatch} ReduxDispatch
 * @typedef {import("../../types/PL_ReduxTypes").ReduxGetState} ReduxGetState
 * 
 * @typedef {import("../../types/PL_ReduxTypes").PL_FullState} PL_FullState
 * 
 * @typedef {import("./liveMapPageTypes").LivemapLocationDetailsResponseModel} LivemapLocationDetailsResponseModel
 * 
 * 
 */





/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {

  LIVEMAP_PAGE__FETCHSETTINGS_STARTED: 'LIVEMAP_PAGE__FETCHSETTINGS_STARTED',
  LIVEMAP_PAGE__FETCHSETTINGS_FINISHED: 'LIVEMAP_PAGE__FETCHSETTINGS_FINISHED',

  LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_STARTED: 'LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_STARTED',
  LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_FINISHED: 'LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_FINISHED',
  LIVEMAP_PAGE__TOOLTIP_LOCATION_HIDE: 'LIVEMAP_PAGE__TOOLTIP_LOCATION_HIDE',
  
  LIVEMAP_PAGE__FULLSTATUS_FETCHDATA_FINISHED: 'LIVEMAP_PAGE__FULLSTATUS_FETCHDATA_FINISHED',
  

  LIVEMAP_PAGE__SEARCH_FETCHDATA_STARTED: 'LIVEMAP_PAGE__SEARCH_FETCHDATA_STARTED',
  LIVEMAP_PAGE__SEARCH_FETCHDATA_FINISHED: 'LIVEMAP_PAGE__SEARCH_FETCHDATA_FINISHED',
  LIVEMAP_PAGE__SEARCHRESULTS_HIDE: 'LIVEMAP_PAGE__SEARCHRESULTS_HIDE',


};


////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {


  fetchMapSettingsStarted: function () {
    return { type: actionTypes.LIVEMAP_PAGE__FETCHSETTINGS_STARTED };
  },


  /** @param {any} payload */
  fetchMapSettingsFinished: function (payload) {
    return { type: actionTypes.LIVEMAP_PAGE__FETCHSETTINGS_FINISHED, payload: payload };
  },


  tooltipLocationHide: function () {
    return { type: actionTypes.LIVEMAP_PAGE__TOOLTIP_LOCATION_HIDE };
  },
  fetchLocationDetailsStarted: function () {
    return { type: actionTypes.LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_STARTED };
  },
  
  /** @param {any} payload */
  fetchLocationDetailsFinished: function (payload) {
    return { type: actionTypes.LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_FINISHED, payload: payload };
  },


  /** @param {any} payload */
  fetchFullStatusFinished: function (payload) {
    return { type: actionTypes.LIVEMAP_PAGE__FULLSTATUS_FETCHDATA_FINISHED, payload: payload };
  },


  mapSearchStarted: function () {
    return { type: actionTypes.LIVEMAP_PAGE__SEARCH_FETCHDATA_STARTED };
  },
  
  /** @param {any} payload */
  mapSearchFinished: function (payload) {
    return { type: actionTypes.LIVEMAP_PAGE__SEARCH_FETCHDATA_FINISHED, payload: payload };
  },
  hideMapSearchResults: function () {
    return { type: actionTypes.LIVEMAP_PAGE__SEARCHRESULTS_HIDE };
  },


};


/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

/** @param {any} data */
jsxActions.fetchMapSettings = function (data) {
  
  return function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
    api.fetchMapSettings(dispatch, getState)(data);
  }
};

/** @param {any} data */
jsxActions.fetchLocationDetails = function (data) {
  return function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
    api.fetchLocationDetails(dispatch, getState)(data);
  }
};

/** @param {any} data */
jsxActions.fetchFullStatus = function (data) {
  return function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
    api.fetchFullStatus(dispatch, getState)(data);
  }
};

/** @param {any} data */
jsxActions.hideLocationTooltip = function (data) {
  return function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
    api.hideLocationTooltip(dispatch, getState)(data);
  }
};

/** @param {any} data */
jsxActions.searchMap = function (data) {
  return function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
    api.searchMap(dispatch, getState)(data);
  }
};

/** @param {any} data */
jsxActions.hideMapSearchResults = function (data) {
  return function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
    api.hideMapSearchResults(dispatch, getState)(data);
  }
};



/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};



api.fetchMapSettings = function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
  
  /**
   * @param {string | number} mapId
   */
  return function(mapId) {

    // console.log(`fetchMapSettings API START ===> `);
    
    dispatch(actions.fetchMapSettingsStarted());

    // @ts-ignore
    return liveMapService.fetchMapSetting(mapId).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Fetch Map Settings Failed');
        // messageDialogApi.responseError(dispatch, getState)(response);
        return { success: false };
      }
      
      // console.log('response ===> ', response);
      // console.log('response.dataList ===> ', response.dataList);
      
      
      // let activeMaps = response.dataList.filter((item) => {
      //   return item.enabled;
      // });
      // // console.log('activeMaps ===> ', activeMaps);
      // let activeMapInfo = activeMaps[0];
      
      let activeMapInfo = response.data;
      let mapName = activeMapInfo.name;
      
      
      //////////////////////////////
      // Set page header data.
      // 
      let topNavigatorData = {
        // name: createLabelHelper('mat.sideNavigator.').get('managerView'),
        name: mapName,
        // type: navigationStates.MANAGER_REPORT,
        type: navigationStates.LIVE_MAP,
        id: -1,
        components: []
      };

      navigatorApi.setData(dispatch, getState)(topNavigatorData);      
      
      

      dispatch(actions.fetchMapSettingsFinished(activeMapInfo));
    });


  }
};


api.fetchLocationDetails = function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
  
  /**
   * @param {{ externalId: string; }} requestData
   */
  return function (requestData) {

    // let externalId = requestData.externalId;
    // if (!externalId) {
    //   return;
    // }

    console.log(`fetchLocationDetails ===> `, requestData);
    
    
    //////////////////////////////////////////////////
    // Try finding locally in current fullStatus.
    //
    
    let state = getState();
    let foundItem = findItemInFullStatus(state, requestData);
    // console.log(`XXXXXXXXXXXXXXXXXXX foundItem ===> `, foundItem);
    
    if (foundItem) {
      augmentLocationDetailsServerItem(state, foundItem);
      // console.log('XXXXXXXXXXXXXXXXXXX foundItem AUGMENTED ===> ', foundItem);
      dispatch(actions.fetchLocationDetailsFinished(foundItem));
      return;
    }
    
    
    ////////////////////////////////////////////////////
    // Not found locally, don't fetch from server.
    //
    dispatch(actions.fetchLocationDetailsStarted()); // Needed for proper state change to trigger render on consecutive null ("no data") responses.
    dispatch(actions.fetchLocationDetailsFinished(null));
    
    
    // //////////////////////////////////////////////////
    // // Fallback:
    // // Fetch from server instead.
    // //

    // dispatch(actions.fetchLocationDetailsStarted());
    
    // if (!liveMapService) {
    //   return;
    // }
    
    
    
    // let networkPromise = liveMapService.fetchLocationDetails(requestData);
    // if (!networkPromise) {
    //   return;
    // }
    
    // return networkPromise.then((response) => {
    //   if (!Network.isResponseValid(response)) {
    //     console.debug('Fetch Location Details Failed');
    //     // messageDialogApi.responseError(dispatch, getState)(response);
    //     dispatch(actions.fetchLocationDetailsFinished(null));
    //     return { success: false };
    //   }


    //   let item = response.data;
    //   augmentLocationDetailsServerItem(getState(), item);

    //   dispatch(actions.fetchLocationDetailsFinished(response.data));
    // });
    
  }
};


api.fetchFullStatus = function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
  
  /** @param {any} requestData */
  return function (requestData) {

    // console.log(`fetchFullStatus ===> `, requestData);

    // dispatch(actions.fetchLocationDetailsStarted());

    // @ts-ignore
    return liveMapService.fetchFullStatus(requestData).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Fetch Full Status Failed');
        // messageDialogApi.responseError(dispatch, getState)(response);
        dispatch(actions.fetchFullStatusFinished(null));
        return { success: false };
      }

      dispatch(actions.fetchFullStatusFinished(response.data));
      
      
      
      /////////////////////////////////////////
      // Call tooltip data API if opened.
      //
      
      let state = getState();
      let liveMapState = state.liveMapPage.toJS();
      
      if (liveMapState.locationTooltipState === 'VISIBLE') {
      
        let tooltipLocation = liveMapState.locationDetails;
        if (tooltipLocation) {
          api.fetchLocationDetails(dispatch, getState)({ externalId: tooltipLocation.name });
        }
        
      } 
      
      
    });


  }
};


api.hideLocationTooltip = function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
  
  /** @param {any} requestData */
  return function (requestData) {
    // console.log(`hideLocationTooltip ===> `,  requestData);
    dispatch(actions.tooltipLocationHide());
  }
};


api.searchMap = function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
  
  /** @param {any} requestData */
  return function (requestData) {

    // console.log(`fetchMapSettings API START ===> `);

    dispatch(actions.mapSearchStarted());

    // @ts-ignore
    return liveMapService.searchMap(requestData).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Search Map Failed');
        // messageDialogApi.responseError(dispatch, getState)(response);
        return { success: false };
      }

      // console.log(`searchMap ok ===> `,  response);
      // console.log(`searchMap ok ===> `,  response.data);
      dispatch(actions.mapSearchFinished(response.data));
    });


  }
};


api.hideMapSearchResults = function (/** @type {ReduxDispatch} */ dispatch, /** @type {ReduxGetState} */ getState) {
  
  /** @param {any} requestData */
  return function (requestData) {
    // console.log(`hideMapSearchResults ===> `,  requestData);
    dispatch(actions.hideMapSearchResults());
  }
  
};





//////////////////////////////////////////////////////////////////


/**
 * @param {PL_FullState} state
 * @param {{ externalId: string; }} requestData
 */
function findItemInFullStatus(state, requestData) {
  let externalId = requestData.externalId;
  if (!externalId) {
    return null;
  }
  
  
  let sMapState = state?.liveMapPage;
  if (!sMapState) {
    return null;
  }
  let mapState = sMapState.toJS();
  
  let fullStatus = mapState.fullStatus;
  if (!fullStatus) {
    return null;
  }

  
  let foundSection = fullStatus.sections.find((item) => {
    return item.name === externalId;
  });
  if (foundSection) {
    return foundSection;
  }
  
  let foundStation = fullStatus.stations.find((item) => {
    return item.name === externalId;
  });
  if (foundStation) {
    return foundStation;
  }
  
  return null;
}



/**
 * @param {PL_FullState} state
 * @param {LivemapLocationDetailsResponseModel} item
 */
function augmentLocationDetailsServerItem(state, item) {

  let labels = createLabelHelper('mat.reports.managerView.');

  let serverTimeSeconds = state.system.get('serverDatetime');
  item.m_ActivityTime = DateTimeHelper.FormatDateObjectToRelativeTime(item.activityTime, serverTimeSeconds);
  item.m_name = item.active ? item.name : item.name + ' (' + labels.get('inactive') + ')';
  
}